import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import RatingStars from '~/components/molecules/Global/RatingStars.vue';
export default {
  name: 'MerchantReinsurance',
  components: {
    RatingStars
  },
  props: {
    merchant: {
      type: Object,
      required: true
    },
    isMarketplace: {
      type: Boolean,
      required: false
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    merchantUrl() {
      return this.buildMerchantUrl(this.locale, this.merchant.reference);
    }

  }),
  methods: {
    handleClickMerchant(event) {
      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_vendeur',
          event_label: this.merchant.name
        }
      });
    },

    handleClickRating(event) {
      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_avis_vendeur',
          event_label: this.merchant.name
        }
      });
    }

  }
};